import http from "../http-common";
/* eslint-disable */
class PasienService {
  pasienList(page, itemPerPage, keyword, nik) {
    return http.get(
      "/pasien/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&nik=" +
        nik,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  getPasien(id) {
    return http.get(`/pasien/${id}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data, photo) {
    var bodyFormData = new FormData();

    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.phone) bodyFormData.append("phone", data.phone);
    if (data.email) bodyFormData.append("email", data.email);
    if (data.no_ktp) bodyFormData.append("no_ktp", data.no_ktp);
    if (data.tempat_lahir)
      bodyFormData.append("tempat_lahir", data.tempat_lahir);

    if (data.tanggal_lahir)
      bodyFormData.append("tanggal_lahir", data.tanggal_lahir);

    if (data.address) bodyFormData.append("address", data.address);

    if (data.selectedJenisKelamin && data.selectedJenisKelamin != undefined) {
      bodyFormData.append("jenis_kelamin_id", data.selectedJenisKelamin.code);
    }

    if (data.selectedAgama && data.selectedAgama != undefined) {
      bodyFormData.append("agama_id", data.selectedAgama.code);
    }

    if (data.selectedPropinsi && data.selectedPropinsi != undefined) {
      bodyFormData.append("propinsi_id", data.selectedPropinsi.id);
    }

    if (data.selectedKabupaten && data.selectedKabupaten != undefined) {
      bodyFormData.append("kabupaten_id", data.selectedKabupaten.id);
    }

    if (data.selectedKecamatan && data.selectedKecamatan != undefined) {
      bodyFormData.append("kecamatan_id", data.selectedKecamatan.id);
    }

    if (data.selectedKelurahan && data.selectedKelurahan != undefined) {
      bodyFormData.append("kelurahan_id", data.selectedKelurahan.id);
    }

    if (photo != null) bodyFormData.append("photo", photo);

    return http.post("/pasien", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(id, data, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.phone) bodyFormData.append("phone", data.phone);
    if (data.email) bodyFormData.append("email", data.email);

    if (data.no_ktp) bodyFormData.append("no_ktp", data.no_ktp);
    if (data.tempat_lahir)
      bodyFormData.append("tempat_lahir", data.tempat_lahir);

    if (data.tanggal_lahir)
      bodyFormData.append("tanggal_lahir", data.tanggal_lahir);

    if (data.address) bodyFormData.append("address", data.address);

    if (data.selectedJenisKelamin && data.selectedJenisKelamin != undefined) {
      bodyFormData.append("jenis_kelamin_id", data.selectedJenisKelamin.code);
    }

    if (data.selectedAgama && data.selectedAgama != undefined) {
      bodyFormData.append("agama_id", data.selectedAgama.code);
    }

    if (data.selectedPropinsi && data.selectedPropinsi != undefined) {
      bodyFormData.append("propinsi_id", data.selectedPropinsi.id);
    }

    if (data.selectedKabupaten && data.selectedKabupaten != undefined) {
      bodyFormData.append("kabupaten_id", data.selectedKabupaten.id);
    }

    if (data.selectedKecamatan && data.selectedKecamatan != undefined) {
      bodyFormData.append("kecamatan_id", data.selectedKecamatan.id);
    }

    if (data.selectedKelurahan && data.selectedKelurahan != undefined) {
      bodyFormData.append("kelurahan_id", data.selectedKelurahan.id);
    }

    if (photo != null) bodyFormData.append("photo", photo);

    return http.put(`/pasien/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new PasienService();
